<div class="container-fluid px-0" style="position: relative">
  <!-- Station Summary Component -->
  <app-station-summary
    [connectionIssuesCount]="stationsWithConnectionIssuesCount"
    [missingDataCount]="missingDataCount"
    [isLoadingConnectionIssues]="isLoadingConnectionIssues"
    [isLoadingMissingData]="isLoadingMissingData"
  />

  <!-- SAD Summary Component - DESABILITADO PARA O RELEASE REALIZE01 -->
  <!--
  <app-sad-summary
    [rustAlertCount]="rustAlertCount"
    [generalAlertCount]="generalAlertCount"
    [isLoadingRustAlert]="isLoadingRustAlert"
    [isLoadingGeneralAlert]="isLoadingGeneralAlert"
  />
  -->

  <!-- Meteorological Data Component - DESABILITADO PARA O RELEASE REALIZE01 -->
  <!--
  <app-meteorological-data
    [stations]="averageStations"
    [nearestStationId]="nearestStationDetail?.id ?? null"
  />
  -->
</div>
